import { Pipe, PipeTransform } from '@angular/core';
import { ObjectTitleService } from '../fi-services/object-title.service';

@Pipe({
    name: 'titleCreate',
    standalone: false,
})
export class TitleCreatePipe implements PipeTransform {
    constructor(private objectTitleService: ObjectTitleService) {}

    transform(value: any, args?: any): any {
        return this.objectTitleService.getCreateTitle(value);
    }
}
